<div id="main-container" class="col-md-4 gradientBg">
  <h1>{{ mainTitle }}</h1>
</div>
<div id="questionLists">
  @for (summary of summaries; track summary) {
    <div class="col-md-10 mt-5 pb-3">
      <p>{{ summary.subtext }}</p>
      <p>{{ summary.subtext2 }}</p>
      <br />
      <h2>{{ summary.title }}</h2>
      <p>{{ summary.subtext3 }}</p>
      <p>{{ summary.text }}</p>
      <p>{{ summary.text2 }}</p>
    </div>
  }
  <!-- Past Chairs of CHCC -->
  <h2>Past Chairs of CHCC</h2>
  <div class="container">
    <div class="row">
      @for (history of histories; track history) {
        <div class="col-md-4">
          <p>
            {{ history.text }}
            <br />
            {{ history.text2 }}
            <br />
            {{ history.text3 }}
          </p>
        </div>
      }
    </div>
  </div>
</div>
